import React from "react";
import Checkbox from "src/components/Shared/Forms/Inputs/Checkbox";
import UserProfile from "src/components/Users/UserProfile";
import { authorizeUserComponentAccess } from "src/helpers/authorizeUserComponentAccess";

const WorkspacePermissionTabDataItem = ({ workspaceId, workspaceDetails, disabledColumns, userPermission, user, selectedTab, permissionChange = () => {} }) => {
  // const formatMemberDate = (date) => {
  //   if (!date) return "";
  //   return moment(new Date(date)).format("MM/DD/YYYY");
  // };

  // const insertTypes = {
  //   SSO_LOGIN: "SSO",
  //   MANUAL_INPUT: "Manually",
  //   BULK_UPLOAD: "Bulk",
  // };

  const handlePermissionChange = (e) => {
    let authorized = authorizeUserComponentAccess(userPermission, workspaceId, "permission", ["update"]);
    if (authorized) {
      permissionChange(e, user);
    }
  };

  return (
    <>
      <div className="flex items-center gap-4 py-4 even:bg-slate-50 odd:bg-white">
        <div className="w-full min-w-[180px] md:min-w-[320px] max-w-[400px]">
          <div className="w-full flex items-center gap-3 px-4">
            <div className="w-10 h-10 min-w-[40px] min-h-[40px] hidden md:flex items-center justify-center font-bold uppercase bg-slate-200 rounded-full">
              <UserProfile user={user?.user_id} />
            </div>
            <div className="w-full">
              <div className="text-sm text-slate-800 font-semibold">{user?.user_id?.name}</div>
              <div className="text-xs sm:text-sm text-slate-400">{user?.user_id?.email}</div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 items-center w-16 sm:min-w-[64px]">
          <Checkbox
            disabled
            checkboxName={selectedTab + "_read"}
            isChecked={user[selectedTab + "_create"] || user[selectedTab + "_update"] || user[selectedTab + "_delete"]}
            forceCheck
          />
        </div>
        <div className="flex flex-col gap-2 items-center w-16 sm:min-w-[64px]">
          <Checkbox
            disabled={disabledColumns.includes("create")}
            checkboxName={selectedTab + "_create"}
            isChecked={user[selectedTab + "_create"]}
            onChange={handlePermissionChange}
          />
        </div>
        <div className="flex flex-col gap-2 items-center w-16 sm:min-w-[64px]">
          <Checkbox
            disabled={disabledColumns.includes("update")}
            checkboxName={selectedTab + "_update"}
            isChecked={user[selectedTab + "_update"]}
            onChange={handlePermissionChange}
          />
        </div>
        <div className="flex flex-col gap-2 items-center w-16 sm:min-w-[64px]">
          <Checkbox
            disabled={disabledColumns.includes("delete")}
            checkboxName={selectedTab + "_delete"}
            isChecked={user[selectedTab + "_delete"]}
            onChange={handlePermissionChange}
          />
        </div>
      </div>
    </>
  );
};

export default WorkspacePermissionTabDataItem;
